import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GroupMembership, User } from 'src/app/shared/models/interfaces';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userUrl = `${environment.api}/user`;
  private reportsUrl = `${environment.api}/reports`;
  
  constructor(private http: HttpClient) {}

  // Fetch the user's profile
  getProfile(): Observable<any> {
    return this.http.get(`${this.userUrl}/profile`);
  }

  // Update the user's profile
  updateProfile(user: Partial<User>): Observable<any> {
    return this.http.patch(`${this.userUrl}/profile`, user);
  }

  // Delete the user's profile and redirect to the home page
  // This will anonymize all associated data
  anonymizeUsersPersonalData(): Observable<any> {
    return this.http.delete(`${this.userUrl}/profile`);
  }

  joinGroup(groupCode: string): Observable<any> {
    return this.http.post(`${this.userUrl}/groups/join`, { groupCode });
  }

  leaveGroup(groupId: number): Observable<any> {
    return this.http.delete(`${this.userUrl}/groups/${groupId}`);
  }

  skipGroupJoining(): Observable<any> {
    return this.http.post(`${this.userUrl}/groups/skip`, {});
  }

  // Fetch groups for the user
  getGroupsForUser(): Observable<GroupMembership[]> {
    return this.http.get<GroupMembership[]>(`${this.userUrl}/groups`);
  }

  // Set new favorite group for the user
  setFavoriteGroup(groupId: number): Observable<GroupMembership[]> {
    return this.http.patch<GroupMembership[]>(`${this.userUrl}/groups/favorite`, { groupId });
  }

  // Fetch the user's emissions report
  getMyEmissionsReport(): Observable<any> {
    return this.http.get(`${this.reportsUrl}/my-emissions`);
  }
}
